export interface GeneratorSchemaBase {
  path: string;
  stories: boolean;
}
